import clsx from 'clsx';
import { FormattedMessage } from 'react-intl';

import { useOpening } from '@/components/pages/job-posting/use-opening';
import { Checkbox } from '@/components/ui/checkbox';
import { Typography } from '@/components/ui/typography';

interface OpeningItemProps {
  openingId: string;
  isSelected: boolean;
  isUnsupported: boolean;
  isAlreadySelected: boolean;
  onSelectionChange: (openingId: string) => void;
}

export function OpeningItem({
  openingId,
  isSelected,
  isUnsupported,
  isAlreadySelected,
  onSelectionChange,
}: OpeningItemProps) {
  const { title } = useOpening(openingId);

  const disabled = isUnsupported || isAlreadySelected;

  return (
    <>
      <div
        className={clsx(
          'flex items-center gap-2 p-4',
          disabled && 'bg-fx-neutral-100',
        )}
      >
        <Checkbox
          checked={isSelected}
          disabled={disabled}
          onCheckedChange={() => onSelectionChange(openingId)}
        />
        <div className="flex flex-col gap-1">
          {/* Opening name */}
          <Typography variant="subtitle1" className="text-fx-neutral-900">
            {title}
          </Typography>

          {/* Unsupported message */}
          {isUnsupported && (
            <Typography variant="small1" className="text-fx-neutral-600 italic">
              <FormattedMessage
                defaultMessage="Not available in this location"
                description="Message to show when an opening is not available in the current location"
              />
            </Typography>
          )}

          {/* Is opening already selected for the channel */}
          {isAlreadySelected && (
            <Typography variant="small1" className="text-fx-neutral-600 italic">
              <FormattedMessage
                defaultMessage="Already selected for this channel"
                description="Message to show when an opening is already selected for the channel"
              />
            </Typography>
          )}
        </div>
      </div>
      <div className="bg-fx-neutral-200 h-px w-full" />
    </>
  );
}
